import { CampingStyleProps } from "~/interfaces"

const checkIsKidsPrereqPresent = (campingStyle: CampingStyleProps) => {
  if (!campingStyle) return false

  return (
    !!campingStyle?.extra_kid_campers_age ||
    !!campingStyle?.extra_kid_campers_price_in_cents ||
    !!campingStyle?.max_free_kid_campers ||
    !!campingStyle?.kids_capacity
  )
}

export default checkIsKidsPrereqPresent
